import { CountryConfig, Configurable } from '@crystal/config'

import { MfSiteConfig } from '../types'

const mfSiteConfig = Configurable.props<Partial<MfSiteConfig>>({
  socialProviders: [
    {
      id: 'apple',
      displayName: 'Apple',
    },
    {
      id: 'facebook',
      displayName: 'Facebook',
    },
    {
      id: 'google',
      displayName: 'Google',
    },
    {
      id: 'yahoo',
      displayName: 'Yahoo',
    },
  ],
})

export const US: CountryConfig<Partial<MfSiteConfig>> = {
  US: mfSiteConfig,
}
